import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { sanitizeHref, URLS } from '@wix/da-url';

import { PAYPAL_USER_AGREEMENT_URL } from '../../modals/consts';
import s from './PayPalPaymentTerms.scss';

export interface Props {
  className?: string;
}

const PayPalPaymentTerms: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['terms']}>
        {t('studio.earnings.withdrawToPayPal.confirmation.termsPrefix')}{' '}
        <a href={URLS.TOS} className="text-link-level-2-secondary">
          {t('studio.earnings.withdrawToPayPal.confirmation.termsLink')}
        </a>{' '}
        {t('studio.earnings.withdrawToPayPal.confirmation.termsAnd')}{' '}
        <a href={sanitizeHref(PAYPAL_USER_AGREEMENT_URL)} className="text-link-level-2-secondary">
          {t('studio.earnings.withdrawToPayPal.confirmation.userAgreementLink')}
        </a>
        .
      </div>
    </div>
  );
};

PayPalPaymentTerms.displayName = 'PayPalPaymentTerms';

export default PayPalPaymentTerms;
